import * as React from "react";
import Tab from "../common/Tab/Tab";
import TabItem from "../common/Tab/TabItem";
import { useTranslation } from "react-i18next";

const ManageAccountTab: React.FunctionComponent<{ selectedTab: string; isAvastId: boolean }> = (props) => {
    const { t: tLang } = useTranslation();
    return (
        <Tab tabId="manage-account-tabs">
            <TabItem
                title={props.isAvastId ? "My Profile" : tLang("manageAccount.myAccount.tabTitle")}
                link="/manage-account/my-account"
                tabNo="1"
                selectedTab={props.selectedTab}
            />
            <TabItem title={tLang("manageAccount.protectionPlan.tabTitle")} link="/manage-account/protection-plan" tabNo="2" selectedTab={props.selectedTab} />
            <TabItem title={tLang("manageAccount.myServices.tabTitle")} link="/manage-account/my-services" tabNo="3" selectedTab={props.selectedTab} />
        </Tab>
    );
};

export default ManageAccountTab;
